import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from "./section1.module.css";
import useTranslation from "next-translate/useTranslation";

var Index = function Index() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsxs("section", {
      className: "".concat(styles.section1, " row"),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("img", {
          className: styles.image1,
          src: "/images/aboutUs/sketch.png",
          alt: ""
        }), /*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:assess')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:assess-explanation')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("img", {
          className: styles.image2,
          src: "/images/aboutUs/wow.png",
          alt: ""
        }), /*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:repeat')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:retrieve-explantaion')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("img", {
          className: styles.image3,
          src: "/images/aboutUs/sign.png",
          alt: ""
        }), /*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:learn-in-sentence')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:learn-in-sentence-explanation')
        })]
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: "".concat(styles.section2, " row "),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:assess')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:assess-explanation')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:repeat')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:retrieve-explantaion')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [/*#__PURE__*/_jsx("p", {
          className: styles.title,
          children: t('aboutUs:learn-in-sentence')
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: t('aboutUs:learn-in-sentence-explanation')
        })]
      })]
    })]
  });
};

export default Index;